module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/index/avatar-male1-db036d07953580f602855d597100a1a0.png";